import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8.883 15.524a.7.7 0 0 0 .287.056.73.73 0 0 0 .53-.22l2.3-2.3 2.3 2.3a.73.73 0 0 0 .53.22.74.74 0 0 0 .53-.22.75.75 0 0 0 0-1.06l-2.3-2.3 2.3-2.3a.75.75 0 0 0-1.06-1.06l-2.3 2.3-2.3-2.3A.75.75 0 0 0 8.64 9.7l2.3 2.3-2.3 2.3a.75.75 0 0 0 .243 1.223" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M12 21.75A9.75 9.75 0 1 1 21.75 12 9.76 9.76 0 0 1 12 21.75m0-18A8.25 8.25 0 1 0 20.25 12 8.26 8.26 0 0 0 12 3.75" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }